export const splashMessageFeatureName = 'splashMessage';
